// Custom delete confirmation modal for content factory posts.
// Optionally collects a deletion reason so we can learn from discarded posts.

import React, { useState } from "react"
import Modal from "react-modal"

import Button from "components/common/Button"
import { Headline3 } from "components/common/styles"
import { modalStyles } from "components/modals/closeComposerModal"

import * as styles from "../styles"

interface DeletePostModalProps {
  isOpen: boolean
  onConfirm: (reason: string) => void
  onClose: () => void
}

const DeletePostModal: React.FC<DeletePostModalProps> = ({
  isOpen,
  onConfirm,
  onClose,
}) => {
  const [reason, setReason] = useState("")
  const reactModalStyles = modalStyles(360)
  const title = "Delete this post?"
  const description = "You are about to delete this post. This can't be undone."

  const handleClose = () => {
    onClose()
    setReason("")
  }

  const handleConfirm = () => {
    onConfirm(reason)
    setReason("")
  }

  return (
    <Modal
      // @ts-ignore
      name={"delete-post-modal"}
      ariaHideApp={false}
      isOpen={isOpen}
      // @ts-ignore
      style={reactModalStyles}
      onRequestClose={() => {}}
    >
      <styles.ModalInfoWrapper>
        <styles.ModalIconWrapper>
          <span className="icon-delete" />
        </styles.ModalIconWrapper>
        <styles.ModalContentWrapper>
          <Headline3>{title}</Headline3>
          <styles.ModalInfoPara>{description}</styles.ModalInfoPara>
        </styles.ModalContentWrapper>
        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Let us know why. It improves future output!"
          rows={3}
          style={{
            width: "100%",
            boxSizing: "border-box",
            padding: "10px 12px",
            borderRadius: "8px",
            border: "1px solid #ddd",
            resize: "vertical",
            fontSize: "14px",
            fontFamily: "inherit",
          }}
        />
        <styles.ModalButtonGroup>
          {/* @ts-ignore */}
          <Button variant="danger" onClick={handleConfirm}>
            Delete post
          </Button>
          {/* @ts-ignore */}
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
        </styles.ModalButtonGroup>
      </styles.ModalInfoWrapper>
    </Modal>
  )
}

export default DeletePostModal
